import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter, Redirect } from 'react-router-dom';
import { Auth } from 'aws-amplify';

import Main from '../components/Main';
import Sidebar from '../components/Sidebar';

const styles = theme => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    height: '100vh',
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    width: '100%',
  },
});

class Home extends Component {
  handleLogout = async event => {
    await Auth.signOut();
    this.props.userHasAuthenticated(false);
  };

  render() {
    const { classes, isAuthenticated } = this.props;

    return isAuthenticated ? (
      <div className={classes.root}>
        <Sidebar handleLogout={this.handleLogout} />
        <Main />
      </div>
    ) : (
      <Redirect from="/home" to="/signin" />
    );
  }
}

export default withRouter(withStyles(styles)(Home));



// WEBPACK FOOTER //
// ./src/containers/Home.js